export type LabeledFiles = { [label: string]: string[] };

export const countNgFiles = (files: LabeledFiles) =>
  Object.entries(files)
    .filter(([label]) => label.toUpperCase() === "NG")
    .reduce((sum, [, paths]) => sum + paths.length, 0);

export const fillNgForTutorial = (source: LabeledFiles, need: number): LabeledFiles | null => {
  const next: LabeledFiles = Object.fromEntries(Object.entries(source).map(([label, paths]) => [label, [...paths]]));
  const ngKey = Object.keys(next).find((label) => label.toUpperCase() === "NG") ?? "NG";
  next[ngKey] = next[ngKey] ?? [];

  const donors = Object.keys(next)
    .filter((label) => label !== ngKey)
    .sort((a, b) => next[b].length - next[a].length);

  const moved: string[] = [];
  for (const label of donors) {
    while (moved.length < need && next[label].length > 0) {
      moved.push(next[label].pop()!);
    }
    if (moved.length >= need) break;
  }
  if (moved.length < need) return null;

  next[ngKey] = [...next[ngKey], ...moved];
  return next;
};
